// extracted by mini-css-extract-plugin
export default {"badge":"PriorityBadge_badge__Udt0T","high":"PriorityBadge_high__K0TvV","medium":"PriorityBadge_medium__QDL98","low":"PriorityBadge_low__cXnaP"};